module.exports = "<div class=\"layout-container\">\r\n  <div class=\"layout\">\r\n    <psm-section class=\"w-100 h-80\" [id]=\"0\"></psm-section>\r\n    <psm-section class=\"w-100 h-20\" [id]=\"1\"></psm-section>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/layouts/layouts/twoSectionsVerticalLayoutMirror/twoSectionsVerticalLayoutMirror.component.html
// module id = ./src/app/views/presentations/layouts/layouts/twoSectionsVerticalLayoutMirror/twoSectionsVerticalLayoutMirror.component.html
// module chunks = main